<template>
  <div class="side-menu-container">
    <ul class="side-list">
      <li v-for="(item, index) in sideList" :key="index">
        <router-link :to="item.link">
          {{ item.title }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    sideList: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss">
.side-menu-container {
  width: 100%;
  ul.side-list {
    padding-top: 31px;
    li {
      color: #666666;
      font-size: 14px;
      margin: 0 0 22px 21px;
      line-height: 14px;
      cursor: pointer;
    }
  }
}
</style>

<style lang="scss">
.router-link-exact-active {
  color: #d21e27;
  font-weight: bold;
}
</style>
